// extracted by mini-css-extract-plugin
export default {"imageAttachmentContent":"AttachmentBoxStyles_imageAttachmentContent__PDA4e","downloadIcon":"AttachmentBoxStyles_downloadIcon__V1hMR"};